"use client";

import SliderNoArrows from "@/components/Carousel/SliderNoArrows";
import Testimonial from "@/components/Text/Testimonial";
import { TestemonialBlackImg } from "@/stories/Testemonial.stories";
import { shuffle } from "@/utils";
import { SwiperSlide } from "swiper/react";
import testimonials from "../../../../public/content/testimonials.json";
import Title from "@/components/Text/Title";
import ListItem from "@/components/Text/ListItem";
import Image from "next/image";
import Timeline from "@/components/Timeline/Timeline";
import Button from "@/components/Cards/Button";
import { ButtonDark, ButtonTransparent, LongButton } from "@/stories/Button.stories";
import Triangles from "@/components/Triangles";
import SideBySideText from "@/components/Text/SideBySideText";
import Text from "@/components/Text/Text";
import Card from "@/components/Cards/Card";
import { TextCard } from "@/stories/Card.stories";
import Newsletter from "@/components/Cards/Newsletter";
import { NewsletterYellow } from "@/stories/Newsletter.stories";
import StatisticCard from "@/components/Statistic/StatisticCard";
import { sendGTMEvent } from "@/components/Analytics";

export default function JetztBuchenLayout() {
    const statistics = [
        {
            number: "48",
            text: "Ich benötige keine Informationen von dir, da ich alle notwendigen Daten direkt aus dem Energiefeld lesen kann, vergleichbar mit dem Lesen eines Buches. Es mag erstaunlich klingen, aber tatsächlich werden rund 48% der Fernbehandlungen ohne jegliche vorherige Angaben bestellt.",
            numberColor: "text-greenText",
        },
        {
            number: "3",
            text: "Wusstest du, dass etwa 3% der Fernbehandlungen circa einen Monat dauern? Die überwältigende Mehrheit der Fernbehandlungen ist jedoch längerfristig angelegt.",
            numberColor: "text-yellow",
        },
        {
            number: "74.3",
            text: "Buchen eine Ferhbehandlung, ohne zusätzliche, persönliche Sitzungstermine zu buchen.",
            numberColor: "text-blue",
        },
        {
            number: "0.5",
            text: "Die Geld zurück Garantie ist nicht ganz null, sie liegt im 0.5% Bereich",
            numberColor: "text-zinc-500",
        },
    ];
    const listItems = [
        {
            title: "Keine Energieübertragung",
            content:
                "In der Fernbegleitung sende ich keine Energie, sondern arbeite daran, defekte Energiefelder wieder funktionsfähig zu machen. ",
        },
        {
            title: "Inklusive kostenlose Tagesbehandlung für schwierige Tage",
            content:
                "Die Tagesbehandlung hilft dir, wenn dich gewisse Symptome belasten oder du eine anstrengende Situation zu meistern hast.",
        },
        {
            title: "Probiere es einfach aus",
            content:
                "Damit du meine Fernbehandlung probieren kannst, biete ich eine einmalige 30 Tage Geld-zurück-Garantie an.",
        },
        {
            title: "Wie es deinem Energiefeld geht",
            content:
                "Die Energiefeld-Analyse kann während einer laufenden Fernbehandlung alle 3 Monate bestellt werden, sie hat einen informativen Charakter. " +
                " ",
            price: [" Preis: CHF 17.00 / EURO 17.50 ", " Dauer: 1 - 2 Minuten."],
        },
        {
            title: "Fairer Preis",
            content: "Das Fernbehandlungs-Abo erhältst du zu einem Abo-Preis von  ",
            price: ["CHF 68.00 / EURO 70.00 pro Monat."],
        },
        {
            title: "Bezahlmöglichkeiten",
            content: "Per Rechnung oder direkt und unkompliziert online bezahlen.",
        },
    ];
    const onSideTimeline = [
        {
            title: "",
            content:
                "Um Stress und Überforderungen schnellstmöglich zu reduzieren, konzentriere ich mich auf die dringlichsten Herausforderungen im Energiefeld. Stabilität wird aufgebaut und erste seelische Verletzungen werden repariert.",
            number: "1",
            bulletColor: "#F6C4BB",
            borderColor: "#F2745D",
            months: "3",
            hasMonths: true,
            monthsColor: "text-[#F2745D]",
        },

        {
            title: "",
            content:
                "Die Stabilität nimmt weiter zu und dadurch können verschiedene Prozesse gestärkt werden, einschliesslich der Instandsetzung komplexer seelischer Verletzungen. ",
            number: "2",
            bulletColor: "#C7EDEF",
            borderColor: "#43C2C8",
            months: "6",
            hasMonths: true,
            monthsColor: "text-teal-400 ",
        },
        {
            title: "",
            content:
                "Die Widerstandsfähigkeit nimmt weiter zu, Schwankungen verringern sich. Das Energiefeld kann schneller reagieren und sich effizienter ausgleichen. Das Energiefeld ist immer mehr in der Lage, erneute Verletzungen selbst zu reparieren.",
            number: "3",
            bulletColor: "lightBlue",
            borderColor: "#43C2C8",
            months: "12",
            hasMonths: true,
            monthsColor: "text-[#589CEA] ",
        },
        {
            title: "",
            content:
                "Die Stabilität ist gestiegen, und sie bildet die Grundlage für Belastbarkeit und Nervenstärke. Dies ermöglicht es, selbst schwierigere Probleme mit größerer Leichtigkeit zu lösen. Man arbeitet darauf hin, wind-und wetterfest zu sein.",
            number: "4",
            bulletColor: "#EAF3E1",
            borderColor: "#94CA57",
            months: "24",
            hasMonths: true,
            monthsColor: "text-[#88C544] ",
        },
        {
            title: "",
            content:
                "Die gewonnene Stabilität ist mittlerweile zur Gewohnheit geworden. Frühzeitig erkennt man Probleme und kann proaktiver reagieren. Überforderungen können besser bewältigt werden, was zu einer gesteigerten Leichtigkeit im Leben führt. Die Lebensqualität nimmt stark zu.",
            number: "5",
            bulletColor: "#F1D9FF",
            borderColor: "#AF75D1",
            months: "36",
            hasMonths: true,
            monthsColor: "text-violet-400 ",
        },
        {
            title: "",
            content:
                "Das Energiefeld entwickelt sich kontinuierlich stabil, und man findet immer mehr zu sich selbst. Eine wachsende Anzahl von Lebensbereichen bereitet Freude und ermöglicht die Entfaltung des eigenen Potenzials. Selbst in schwierigen Situationen bleibt man in seiner Kraft. Herausforderungen im Leben mögen bestehen bleiben, aber die innere Stärke, sie zu bewältigen, ist nun um ein Vielfaches grösser.",
            number: "6",
            bulletColor: "#FFEAD2",
            borderColor: "#F7A13C",
            months: "60",
            hasMonths: true,
            monthsColor: "text-[#F7A13C] ",
        },
        {
            title: "Langfristige Entwicklung",
            content:
                "Das Energiefeld wird zunehmend widerstandsfähiger. Wer hierher kommt, möchte starke Energien, die standhaft bleiben, egal was passiert. Die Gewöhnung daran, souveräner zu sein, schafft Freiraum, um voranzuschreiten, kreativer und innovativer zu sein. Denn man muss sich nicht länger mit unwichtigen Dingen auseinandersetzen, die einen überfordern.",
            number: "7",
            bulletColor: "#FFC9D6",
            borderColor: "#E35C7C",
            months: "+",
            hasMonths: true,
            monthsColor: "text-[#E15576] ",
        },
    ];
    const timeline2 = [
        {
            title: "Fülle das Bestellformular aus",
            content:
                "Unkompliziert und einfach holst du dir deine Unterstützung für mehr innere Stärke. Hierfür musst du mir nicht beschreiben, wie es dir geht.",
            number: "1",
            bulletColor: "#F6C4BB",
            borderColor: "#F2745D",
        },
        {
            title: "Individuelle Fernbehandlung",
            content:
                "Meine Fernbehandlung ist ganz auf dich abgestimmt, weil ich deine einzigartige Energiefeldsignatur erkenne.",
            number: "2",
            bulletColor: "#C7EDEF",
            borderColor: "#43C2C8",
        },
        {
            title: "Du musst nichts dabei tun",
            content:
                "Keine Gespräche, keine Termine, keine Einschränkungen, keine Hausaufgaben. Du beobachtest lediglich, wie es dir geht.",
            number: "3",
            bulletColor: "lightBlue",
            borderColor: "#3A88DF",
        },
    ];
    return (
        <>
            <div className="bg-yellow flex justify-center">
                <div className="container bg-yellow w-full md:px-20 lg:py-36 px-3  pb-24 flex-col justify-center items-center gap-6 inline-flex">
                    <Title
                        hasPreTitle={true}
                        preTitle="Bereit für mehr innere Stärke und Stabilität? "
                        title="Hier kannst du die Fernbehandlung BUCHEN"
                        hasSubTitle={true}
                        hasText={false}
                        paddings="px-3 pt-24 lg:px-20"
                        subtitleSize="leading-7 lg:leading-loose text-xl lg:text-2xl"
                        subtitleStyle=""
                        subTitle="Zu Beginn der Fernbehandlung analysiere ich dein Energiefeld. Diese Analyse zeigt mir klar, wo ich ansetzen muss, um deine Energiefelder zu reparieren und zu stärken. Mein Ziel ist es, dich zu unterstützen, um deine innere Stärke zu entfalten."
                    />
                    {/* <PlayerInPage
                        videoId="2dbd35da8e2700e84eb733cf0bf98615"
                        thumbnail="/images/thumbnails/jetztThumbnail.jpg"
                    /> */}
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-white" buttomToTop={false} />
            </div>
            <div className="bg-white w-full lg:px-36 md:px-20  flex-col justify-center items-center gap-6 inline-flex">
                {/* <SideBySideText
                    backgroundColor="bg-white"
                    elementRight={
                        <div className="">
                            <div className="space-y-5 lg:pt-42">
                                {listItems.slice(3).map((item) => (
                                    <div key={item.title}>
                                        <ListItem
                                            title={item.title}
                                            content={item.content}
                                            icon={"/Icons/checkGreen.svg"}
                                            price={item.price}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className="justify-start items-center gap-2 inline-flex">
                                <div className="lg:hidden block">
                                    <Image
                                        alt=""
                                        width={300}
                                        height={100}
                                        src="/images/cardsJetsSm.png"
                                    />
                                </div>
                                <div className="lg:block hidden">
                                    <Image
                                        alt=""
                                        width={500}
                                        height={70}
                                        src="/images/cardsJetsLg.png"
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    elementLeft={
                        <div className="space-y-4">
                            <p className="text-black lg:text-5xl text-xl3 pb-5 font-bold   lg:leading-14 leading-10">
                                Deine Vorteile mit der Fernbehandlung
                            </p>
                            <div className="space-y-5">
                                {listItems.slice(0, 3).map((item) => (
                                    <div key={item.title}>
                                        <ListItem
                                            title={item.title}
                                            content={item.content}
                                            icon={"/Icons/checkGreen.svg"}
                                            price={item.price}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    }
                /> */}
                <div className="space-y-5 py-25 px-3 md:px-0 lg:px-32">
                    <p className="text-black lg:text-5xl text-xl3 pb-5 font-bold  lg:w-1/2 lg:leading-14 leading-10">
                        Deine Vorteile mit der Fernbehandlung
                    </p>
                    <div className="lg:flex ">
                        {listItems.slice(0, 2).map((item) => (
                            <div key={item.title} className="lg:w-1/2">
                                <ListItem
                                    title={item.title}
                                    content={item.content}
                                    icon={"/Icons/checkGreen.svg"}
                                    price={item.price}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="lg:flex ">
                        {listItems.slice(2, 4).map((item) => (
                            <div key={item.title} className="lg:w-1/2">
                                <ListItem
                                    title={item.title}
                                    content={item.content}
                                    icon={"/Icons/checkGreen.svg"}
                                    price={item.price}
                                />
                            </div>
                        ))}
                    </div>
                    <div className="lg:flex ">
                        {listItems.slice(4, 6).map((item) => (
                            <div key={item.title} className="lg:w-1/2">
                                <ListItem
                                    title={item.title}
                                    content={item.content}
                                    icon={"/Icons/checkGreen.svg"}
                                    price={item.price}
                                />
                                {item.title === "Bezahlmöglichkeiten" && (
                                    <div className="justify-start items-center gap-2 inline-flex">
                                        <div className="lg:hidden block">
                                            <Image
                                                alt=""
                                                width={300}
                                                height={100}
                                                src="/images/cardsJetsSm.png"
                                            />
                                        </div>
                                        <div className="lg:block hidden">
                                            <Image
                                                alt=""
                                                width={500}
                                                height={70}
                                                src="/images/cardsJetsLg.png"
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-black" buttomToTop={true} />
            </div>
            <div className="bg-black flex justify-center">
                <div className="container w-full px-3 lg:px-20 py-20 flex-col justify-center items-center gap-6 inline-flex">
                    <div className=" text-center text-white lg:text-5xl  text-xl3 font-bold  lg:leading-14 leading-10">
                        Theoretischer Verlauf der Fernbehandlung
                    </div>
                    <div className=" text-center text-white lg:text-xl1 text-lg  font-normal  leading-7 lg:leading-8.5">
                        Dieser Verlauf zeigt eine Person, die geschwächte Energien und
                        seelische Verletzungen aufweist, jedoch grundsätzlich gut
                        unterwegs ist. Bei jemanden, der sehr tiefe seelischen
                        Verletzungen hat, kann der Prozess länger dauern, während es bei
                        jemandem, der sehr gut unterwegs ist, erheblich schneller gehen
                        kann.
                    </div>
                    <div>
                        <Timeline
                            content={onSideTimeline}
                            layout="1-column-left"
                            lineColor="#000"
                            iconPlacement="-left-5 -top-1"
                        />
                    </div>
                    <div className="flex justify-center">
                        <Button
                            backgroundColor="bg-white"
                            paddings={"py-4 px-2"}
                            border=""
                            hasIcon={false}
                            size={ButtonTransparent.args?.size}
                            text="Jetzt buchen"
                            textColor={ButtonTransparent.args?.textColor}
                            as="a"
                            href="/de/bestellen"
                            onClick={() => {
                                sendGTMEvent({
                                    event: "cta_click",
                                    section_title:
                                        "Theoretischer Verlauf der Fernbehandlung",
                                    section_index: "3",
                                    cta_text: "Jetzt buchen",
                                    cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="bg-black -mb-[0.1rem]">
                <Triangles backgroundColor="bg-orange" buttomToTop={false} />
            </div>
            <div className="bg-orange flex justify-center">
                <div className="container w-full  px-3 lg:px-20 flex-col justify-center items-center gap-6 inline-flex">
                    <SideBySideText
                        backgroundColor="bg-orange"
                        elementLeft={
                            <>
                                <div className="flex justify-center">
                                    <Image
                                        alt=""
                                        width={200}
                                        height={200}
                                        src="/images/stamp.svg"
                                    />
                                </div>
                            </>
                        }
                        elementRight={
                            <div>
                                <Text
                                    title="Ich biete die 30-Tage-Geld-zurück-Garantie an."
                                    hasPretitle={false}
                                    hasSubTitle={false}
                                    hasText={false}
                                    paddings=""
                                    titlePlacement="text-center lg:text-start"
                                    leading="leading-8"
                                />
                                <div className="pt-5 flex md:justify-start lg:justify-start justify-center">
                                    <Button
                                        backgroundColor={"bg-black"}
                                        border={ButtonDark.args?.border}
                                        rounded={ButtonDark.args?.rounded}
                                        text="Erfahre mehr"
                                        size={ButtonDark.args?.size}
                                        as="a"
                                        href="/de/30-tage-geld-zuruck-garantie"
                                        onClick={() => {
                                            sendGTMEvent({
                                                event: "cta_click",
                                                section_title:
                                                    "Ich biete die 30-Tage-Geld-zurück-Garantie an.",
                                                section_index: "4",
                                                cta_text: "Erfahre mehr",
                                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/30-tage-geld-zuruck-garantie`,
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        }
                    />
                </div>
            </div>
            <div className="bg-orange">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
            <div className="bg-white w-full  px-3 lg:px-20 py-40 flex-col justify-center items-center gap-6 inline-flex">
                <div className=" text-center text-black text-xl3 lg:text-5xl font-bold  leading-10 lg:leading-14">
                    In 3 Schritten zu deiner Fernbehandlung
                </div>
                <div className="lg:block hidden">
                    <Timeline
                        content={timeline2}
                        layout="2-columns"
                        lineColor="#F1F1F1"
                    />
                </div>
                <div className="lg:hidden block">
                    <Timeline
                        content={timeline2}
                        layout="1-column-right"
                        lineColor="#F1F1F1"
                    />
                </div>
                <div>
                    <Button
                        backgroundColor={LongButton.args?.backgroundColor}
                        border={LongButton.args?.border}
                        rounded={LongButton.args?.rounded}
                        text="Jetzt buchen "
                        size={LongButton.args?.size}
                        hasIcon={LongButton.args?.hasIcon}
                        as="a"
                        href="/de/bestellen"
                        textColor={LongButton.args?.textColor}
                        textSize={LongButton.args?.textSize}
                        paddings={LongButton.args?.paddings}
                        onClick={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "In 3 Schritten zu deiner Fernbehandlung",
                                section_index: "5",
                                cta_text: "Jetzt buchen",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-black" buttomToTop={false} />
            </div>
            <div className="bg-black flex justify-center">
                <div className="container w-full  px-3 lg:px-20 lg:py-20 flex-col justify-center items-center gap-6 inline-flex">
                    <SliderNoArrows
                        paginationColor="#FFFFFF"
                        contentEl={
                            <div className="flex justify-center items-center">
                                {shuffle(testimonials?.testimonials)?.map(
                                    (testimonial) => {
                                        return (
                                            <SwiperSlide key={testimonial.testimonial}>
                                                <Testimonial
                                                    backgroundColor={
                                                        TestemonialBlackImg?.args
                                                            ?.backgroundColor
                                                    }
                                                    differentTextColor={
                                                        TestemonialBlackImg?.args
                                                            ?.differentTextColor
                                                    }
                                                    hasImage={testimonial.hasImage}
                                                    text={testimonial?.testimonial}
                                                    icon={TestemonialBlackImg.args?.icon}
                                                    textColor={
                                                        TestemonialBlackImg.args
                                                            ?.textColor
                                                    }
                                                    name={testimonial?.name}
                                                    hasDescription={false}
                                                    wordsInDifferentColor={[""]}
                                                    hasReadMore={true}
                                                />
                                            </SwiperSlide>
                                        );
                                    },
                                )}
                            </div>
                        }
                    />
                </div>
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
            <div className="bg-white w-full px-3 lg:px-20 py-20 flex-col justify-center items-center gap-6 inline-flex">
                <Card
                    backgroundColor="bg-blue"
                    border={TextCard.args?.border}
                    hasImage={TextCard.args?.hasImage}
                    content={
                        "Ich bleibe mit voller Absicht den Beweis schuldig, dass meine Arbeit wirkt. Es gibt sehr viele Menschen, die von meiner Arbeit profitieren konnten. Es gibt aber auch Menschen, die es nicht spüren konnten und das ist in Ordnung. Man kann nicht immer allen Menschen helfen, auch wenn man es möchte. Darum gebe ich keine Versprechen, was den Erfolg meiner Arbeit anbelangt. Ich gebe mein Bestes, anhand meiner Forschungsarbeiten und der daraus resultierenden Energiefeldmechanik, präzise am Energiefeld zu arbeiten und die Ursachen für Probleme zu lösen. Wenn die Energiefelder funktionieren, dann funktioniert das Leben und macht auch wieder Spass."
                    }
                    hasButton={TextCard.args?.hasButton}
                    contentSize={TextCard.args?.contentSize}
                    pretitle={"Mein Bestes geben"}
                    title={"Ich gebe kein Heilsversprechen"}
                    textColor={TextCard.args?.textColor}
                    titleSize={TextCard.args?.titleSize}
                    textSize={TextCard.args?.textSize}
                    height={" min-h-[580px] pb-6"}
                    width={TextCard.args?.width}
                    hasPretitle={true}
                    pretitleSize="text-[28px] lg:text-xl3 italic"
                />
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-pink " buttomToTop={false} />
            </div>
            <div className="bg-pink">
                <div className="container w-full py-16 px-3 gap-6 md:px-5 grid grid-cols-1 lg:grid-cols-2 md:grid-cols-2">
                    {statistics.map((stat) => {
                        return (
                            <div key={stat.text}>
                                <StatisticCard
                                    number={stat.number}
                                    numberColor={"text-black"}
                                    text={stat.text}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="bg-pink">
                <Triangles backgroundColor="bg-orange lg:bg-yellow" buttomToTop={true} />
            </div>
            <div className="bg-orange lg:bg-yellow flex justify-center">
                <div className="container py-12   w-full lg:py-30 px-3 lg:px-20 flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        backgroundColor="lg:bg-yellow bg-orange"
                        hasCheckbox={NewsletterYellow.args?.hasCheckbox}
                        hasDescription={NewsletterYellow.args?.hasDescription}
                        hasInput={NewsletterYellow.args?.hasInput}
                        hasSubText={NewsletterYellow.args?.hasSubText}
                        title="Warte nicht länger - pack es an!"
                        buttonText="Jetzt buchen"
                        description="Meine Arbeit hat das Ziel, dir nachhaltig in deine natü rlich Kraft und Stärke zu helfen.  Veränderung ist nur durch Stärke möglich und dazu braucht es funktionierende Energiefelder."
                        buttonAs="a"
                        href="/de/bestellen"
                        paddings="lg:px-36 md:px-20"
                        buttonPaddings="py-4 lg:px-6 px-12"
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "Warte nicht länger - pack es an!",
                                section_index: "9",
                                cta_text: "Jetzt buchen",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellen`,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="bg-orange lg:bg-yellow ">
                <Triangles backgroundColor="bg-darkGray " buttomToTop={false} />
            </div>
        </>
    );
}
